import * as tslib_1 from "tslib";
import { takeUntil } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import * as fromCatalog from '../../reducers';
import * as fromBase from '../../../base/reducers';
import { ContainerBase } from '../../../core/base/container-base';
import { PageRoutingService } from '../../../core/services/page-routing.service';
var ProductPageContainer = /** @class */ (function (_super) {
    tslib_1.__extends(ProductPageContainer, _super);
    function ProductPageContainer(store, pageRouting) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.pageRouting = pageRouting;
        _this.product$ = store
            .pipe(select(fromCatalog.getSelectedProduct), takeUntil(_this.destroyed$));
        // get show breadcrumbs
        _this.store.pipe(select(fromBase.getTenantSettings), takeUntil(_this.destroyed$)).subscribe(function (settings) {
            _this.showCrumbs = settings.show_breadcrumbs;
        });
        // get crumbs
        _this.crumbs$ = _this.pageRouting.breadCrumbs$;
        return _this;
    }
    return ProductPageContainer;
}(ContainerBase));
export { ProductPageContainer };
